import { render, staticRenderFns } from "./reservation-expired.vue?vue&type=template&id=f1596e38&scoped=true"
import script from "./reservation-expired.vue?vue&type=script&lang=js"
export * from "./reservation-expired.vue?vue&type=script&lang=js"
import style0 from "./reservation-expired.vue?vue&type=style&index=0&id=f1596e38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1596e38",
  null
  
)

export default component.exports